import { useSelector } from 'react-redux'
import InvoiceInfo from '../my-profile/InvoiceInfo'
import AddressInfo from '../my-profile/AddressInfo'
import AadharCardInfo from './AadharCardInfo';

function TaxInvoiceAndKyc() {

    const user = useSelector((state) => state.auth.user);

    return (
        <div className="user-profile-main-container">

            <div className="user-profile-container">

                {/* {user?.verification?.aadhar_number && (
                    <AadharCardInfo />
                )} */}

                {user?.verification?.pan_number && (
                    <InvoiceInfo />
                )}

                {user?.address && <AddressInfo />}

            </div>
        </div>
    )
}

export default TaxInvoiceAndKyc;